// this is the long spiral of portraits

import cx from 'classnames'
import { motion } from 'motion/react'
import { FC, useMemo } from 'react'
import { BlockTitleProps } from 'src/components/BlockTitle'
import { PortraitProps } from 'src/components/Portrait'
import { motionSlide } from 'src/hooks/useAppear'

import * as SC from './styled'

export type PortraitGridProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  portraits?: PortraitProps[]
}

const PortraitGrid: FC<PortraitGridProps> = ({
  className,
  portraits,
  blockTitleProps,
}) => {
  const { motions } = usePortraitGridMotion()

  return (
    <SC.Container className={cx('PortraitGrid', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      <SC.Grid>
        {portraits?.map((portrait, index) => (
          <motion.li
            key={`portrait-motion-${index}`}
            {...(index % 2 ? motions.portraitDelayed : motions.portrait)}
          >
            <SC._Portrait {...portrait} />
          </motion.li>
        ))}
      </SC.Grid>
    </SC.Container>
  )
}

const usePortraitGridMotion = () => {
  const motions = useMemo(
    () => ({
      portrait: motionSlide({}).motionProps,
      portraitDelayed: motionSlide({ delay: 0.12 }).motionProps,
    }),
    []
  )

  return { motions }
}

export default PortraitGrid
